import type { FC } from "react";

import type { IComponent } from "@Components/Component";
import * as stylex from "@stylexjs/stylex";

import TextLabel from "./TextLabel";

export interface IComplaintItemNew extends IComponent {
    complainDateLabel: string;
    complainDate: string;
    complaintTypeLabel: string;
    complaintType: string;
    commentComplainLabel: string;
    commentComplain: string;
    cashbackAmountLabel: string;
    cashbackAmount: string;
    isCustomer: boolean;
}

const ComplaintItemNew: FC<IComplaintItemNew> = (props) => {
    const renderComplainDate = () =>
        props.complainDate && (
            <TextLabel
                id="complainDate"
                variant={props.isCustomer ? "blueBorder" : "blueFull"}
                text={props.complainDate}
                labelText={props.complainDateLabel}
            />
        );

    const renderCostumerComment = () =>
        props.isCustomer && (
            <>
                {props.complaintType && (
                    <TextLabel
                        id="complaintType"
                        variant="blueBorder"
                        text={props.complaintType}
                        labelText={props.complaintTypeLabel}
                    />
                )}
                {props.cashbackAmount && (
                    <TextLabel
                        id="complaintCashbackAmount"
                        variant="blueBorder"
                        text={props.cashbackAmount}
                        labelText={props.cashbackAmountLabel}
                    />
                )}
            </>
        );

    const renderCommentComplain = () =>
        props.commentComplain && (
            <TextLabel
                id="commentComplain"
                variant="blueBorder"
                text={props.commentComplain}
                labelText={props.commentComplainLabel}
            />
        );

    return (
        <div>
            {props.complainDate && (
                <div {...stylex.props(styles.complaintDetails)}>
                    {renderComplainDate()}
                    {renderCostumerComment()}
                    {renderCommentComplain()}
                </div>
            )}
        </div>
    );
};

const styles = stylex.create({
    complaintDetails: {
        width: "100%",
        fontSize: "0.75rem",
        lineHeight: 1,
        padding: "5px 0",
    },
});

export default ComplaintItemNew;
